import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from "src/environments/environment";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IApiBase } from "./Interface/IApiBase.interface";
import { IRouteMapRequest } from "src/app/features/map-features/sections/route-section/models/IRouteMapRequest";

@Injectable({
  providedIn: "root",
})
export class RouteMapAPIService implements IApiBase{
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }

  getRouteData ( routeMapRequest: IRouteMapRequest ): any {
    let params = {
      identifier: routeMapRequest.Identifier,
      startDate: routeMapRequest.StartDate,
      endDate: routeMapRequest.EndDate,
      startHour: routeMapRequest.StartHour
    };
    return this.http.post<EstatusJSON>(  this.configUrl + "/api/RouteMap/GetRouteData",  params );
  }

  getRealRouteMap(routeMapRequest: IRouteMapRequest): Observable<EstatusJSON> {
    let params = {
      identifier: routeMapRequest.Identifier,
      startDate: routeMapRequest.StartDate,
      endDate: routeMapRequest.EndDate,
    };
    return this.http.post<EstatusJSON>( this.configUrl + "/api/RouteMap/GetRoutePoints", params ); 
  }

  getRouteMapGeoJson(routeMapRequest: IRouteMapRequest): any {
    let params = {
      identifier: routeMapRequest.Identifier,
      startDate: routeMapRequest.StartDate,
      endDate: routeMapRequest.EndDate,
    };
    return this.http.post<EstatusJSON>( this.configUrl + "/api/RouteMap/GetRouteGeoJson", params );
  }

  GetDirectionByCoords(latitude: any, longitude: any): any {
    if(!environment.production) console.log( this.configUrl + "/api/RouteMap/GetDirectionByCoords?x=" + latitude + "&y=" + longitude );
    return this.http.get<EstatusJSON>( this.configUrl + "/api/RouteMap/GetDirectionByCoords?x=" + latitude + "&y=" + longitude );
  }

  GetRouteDataList(): any {
    if(!environment.production) console.log( this.configUrl + "/api/RouteMap/GetRouteDataList" );
    return this.http.get<EstatusJSON>( this.configUrl + "/api/RouteMap/GetRouteDataList" );
  }
  
}
